<h2 mat-dialog-title>Codes immeuble <small>retournés par {{ provider }}</small></h2>

<mat-dialog-content>
  <div class="p-4">
    <table class="w-full table-fixed border-collapse border border-gray-400">
      <tbody>
        @for (fibreBuildingCode of fibreBuildingCodes; track fibreBuildingCode) {
        <tr>
          <td class="border border-gray-300 p-2">
              {{ fibreBuildingCode }}
          </td>
          <td class="border border-gray-300 p-2 text-center" style="width: 75px">
              <button matIconButton matTooltip="Copier dans le presse-papiers" [cdkCopyToClipboard]="fibreBuildingCode">
                  <mat-icon>content_copy</mat-icon>
              </button>
          </td>
        </tr>
        } @empty {
        <tr>
          <td class="border border-gray-300 p-2">Aucun code immeuble retourné</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</mat-dialog-content>
